import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"

const AboutPage = () => (
  <Layout pageTitle="About Us">
    <SEO title="About" />

  </Layout>
)

export default AboutPage